import React, { FC, ReactNode } from "react";
import classNames from "classnames";

interface StepLayoutProps {
  heading?: string;
  children: ReactNode;
  headerAdditionalContent?: ReactNode;
  className?: string;
}

export const StepLayout: FC<StepLayoutProps> = (props) => {
  const { heading, children, headerAdditionalContent, className } = props;

  return (
    <div className={classNames("StepLayout", className)}>
      <div className="StepLayout__header">
        {heading && <h2 className="StepLayout__heading">{heading}</h2>}
        {headerAdditionalContent}
      </div>
      <div className="StepLayout__content">{children}</div>
    </div>
  );
};
